module.exports = __webpack_public_path__ + "static/img/12-2.b32d09b7.jpg";